export default "__VITE_ASSET__D_zm2LY5__"